import { FC } from 'react';
import { useIntl } from 'react-intl';

import { usePathProps } from '../../modules/user-profile/hooks/usePathProps';
import { PageTitle } from '../../../_metronic/layout/core';
import { PossibleTable } from '../../modules/tasks';

const PossibleComponent: FC = () => {
  return (
    <>
      <PossibleTable />
    </>
  );
};

const PossiblePage: FC = () => {
  const intl = useIntl();
  usePathProps();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'possible.title' })}
      </PageTitle>
      <PossibleComponent />
    </>
  );
};

export { PossiblePage };
